import { Component, OnInit } from '@angular/core';
import { DataMasterService } from 'src/app/services/data-master.service';

@Component({
  selector: 'app-admin-moderators',
  templateUrl: './admin-moderators.component.html',
  styleUrls: ['./admin-moderators.component.scss']
})
export class AdminModeratorsComponent implements OnInit {

  constructor(public dataService : DataMasterService ) {
    this.dataService.setFooter("fixed");
  }

  ngOnInit(): void {
  }

}
